import React, { type ChangeEvent } from 'react'
import styled from 'styled-components'
import { type FlexboxProps } from 'styled-system'
import { Flex } from 'components/Layout'
import { Text } from 'components/Typography'
import { FONT_SIZE, FONT_WEIGHT, SPACE } from 'Theme'
import { type ToggleButtonProps } from './ToggleButton'

const ButtonFlex = styled(Flex)`
  flex-wrap: wrap;
  gap: ${SPACE.PX_8};
`

export interface ToggleButtonGroupProps extends FlexboxProps {
  onChange: (
    event: ChangeEvent<HTMLInputElement>,
    isUnavailable?: boolean
  ) => void
  name: string
  value: string
  label?: string
  labelProps?: React.ComponentProps<typeof Text>
}

export const ToggleButtonGroup: React.FC<React.PWC<ToggleButtonGroupProps>> = ({
  value,
  onChange,
  children,
  name,
  label,
  labelProps,
  ...rest
}) =>
  Boolean(Array.isArray(children) && children.length) && (
    <Flex flexDirection="column" {...rest}>
      {label && (
        <Text
          marginBottom={SPACE.PX_6}
          fontWeight={FONT_WEIGHT.MEDIUM}
          fontSize={FONT_SIZE.PX_13}
          textTransform="capitalize"
          {...labelProps}
        >
          {label}
        </Text>
      )}
      <ButtonFlex>
        {React.Children.map(children, (child) => {
          if (!React.isValidElement(child)) {
            return null
          }

          return React.cloneElement<Partial<ToggleButtonProps>>(child, {
            onChange,
            groupValue: value,
            isUnavailable: child?.props.isUnavailable,
          })
        })}
      </ButtonFlex>
    </Flex>
  )
